<template>
  <div style="background: #f5f5f5; height: 100vh">
    <div class="heard">申请换卡</div>
    <div class="center">
      <div class="title">换卡资料</div>
      <div>
        <van-form
          label-width=".9375rem"
          label-align="center"
          @submit="onSubmit"
        >
          <div class="form">
            <van-field
              v-model="form.name"
              name="姓名"
              label="姓名"
              placeholder="请填写姓名"
              :rules="[{ required: true, message: '请填写姓名' }]"
            />
            <van-field
              v-model="form.phone"
              name="手机号"
              label="手机"
              placeholder="请填写手机号"
              :rules="telRules"
            />
            <van-field
              readonly
              clickable
              name="picker"
              :value="value"
              label="省份"
              :rules="[{ required: true, message: '请选择省份' }]"
              placeholder="点击选择省份"
              @click="showPicker = true"
            />
            <van-popup v-model="showPicker" position="bottom">
              <van-picker
                show-toolbar
                value-key="name"
                :columns="columns"
                @confirm="onConfirm"
                @cancel="showPicker = false"
              />
            </van-popup>
            <van-field
              readonly
              clickable
              name="pickers"
              :value="values"
              label="市区"
              placeholder="点击选择市区"
              :rules="[{ required: true, message: '请选择市区' }]"
              @click="showPickers = true"
            />
            <van-popup v-model="showPickers" position="bottom">
              <van-picker
                show-toolbar
                value-key="name"
                :columns="columnss"
                @confirm="onConfirms"
                @cancel="showPickers = false"
              />
            </van-popup>
            <van-field
              readonly
              clickable
              :rules="[{ required: true, message: '请选择区域' }]"
              name="pickerss"
              :value="valuess"
              label="区域"
              placeholder="点击选择区域"
              @click="showPickerss = true"
            />
            <van-popup v-model="showPickerss" position="bottom">
              <van-picker
                show-toolbar
                value-key="name"
                :columns="columnsss"
                @confirm="onConfirmss"
                @cancel="showPickerss = false"
              />
            </van-popup>
            <van-field
              v-model="form.address"
              name="详细地址"
              label="地址"
              placeholder="请填写详细地址"
              :rules="[{ required: true, message: '请填写详细地址' }]"
            />
            <van-field
              v-if="cards.length > 0"
              readonly
              clickable
              name="picker"
              :value="bnk"
              label="卡种"
              :rules="[{ required: true, message: '请选择卡种' }]"
              placeholder="点击卡种"
              @click="showPicker3 = true"
            />
            <van-popup v-model="showPicker3" position="bottom">
              <van-picker
                show-toolbar
                value-key="name"
                :columns="cards"
                @confirm="onConfirms1"
                @cancel="showPicker3 = false"
              />
            </van-popup>
            <van-field
              v-model="form.remark"
              rows="2"
              autosize
              label="备注"
              type="textarea"
              maxlength="50"
              :rules="[{ required: true, message: '请填写备注' }]"
              placeholder="请输入备注"
              show-word-limit
            />
          </div>
          <div
            v-if="form.postAge != '0' && newPayList.length > 0"
            style="margin: 15px 0"
          >
            <div class="title">换卡邮费：{{ form.postAge }}元</div>
            <div style="background-color: #ffffff">
              <van-radio-group v-model="PayType">
                <div
                  v-for="(item, index) in newPayList"
                  :key="item.name"
                  class="detail-names"
                  :style="{
                    border: index + 1 == newPayList.length ? '0' : '',
                  }"
                >
                  <div class="display-left">
                    <img class="img" :src="item.imageUrl" alt="" />
                    <span>{{ item.name }}</span>
                    <div v-if="qqs == true" class="recommend">
                      <div v-if="item.systemRecommend == 1" class="recommends">
                        推荐
                      </div>
                    </div>
                    <div v-else class="recommend">
                      <div v-if="item.appRecommend == 1" class="recommends">
                        推荐
                      </div>
                    </div>
                  </div>

                  <van-radio class="display-right" :name="item.id"></van-radio>
                </div>
              </van-radio-group>
            </div>
          </div>
          <div style="margin: 16px 0">
            <van-button
              :loading="loadingsa"
              style="width: 100%; border-radius: 10px"
              block
              type="info"
              native-type="submit"
            >
              {{
                form.postAge != "0" && newPayList.length > 0
                  ? "支付并确认"
                  : "确认"
              }}
            </van-button>
          </div>
        </van-form>
      </div>
    </div>
    <van-dialog
      v-model="showse"
      :showConfirmButton="false"
      closeOnClickOverlay
      title="支付金额"
    >
      <div style="font-size: 20px; color: red">
        ￥{{ this.$route.query.type }}元
      </div>
      <div style="margin-top: 10px; margin-bottom: 20px">
        <van-radio-group v-model="form.payId">
          <div v-for="item in zhifu" :key="item.name" class="content">
            <div class="display-left">
              <img class="img" :src="item.imgUrl" alt="" />
              {{ item.showName }}
            </div>
            <div class="recommend">
              <div v-if="item.recommend == 1" class="recommends">推荐</div>
            </div>
            <van-radio class="display-right" :name="item.id"></van-radio>
          </div>
        </van-radio-group>
      </div>
      <div style="width: 100%">
        <van-button
          @click="confirma"
          size="small"
          style="width: 80%; margin: 10px 10%; border-radius: 10px"
          type="info"
        >
          确认支付
        </van-button>
      </div>
    </van-dialog>
    <!-- 支付宝二维码 -->
    <van-action-sheet v-model="showss" cancel-text="取消" close-on-click-action>
      <img style="width: 100%" :src="imagerurl" />
      <div style="text-align: center">
        使用{{ PayType == 1 ? "微信" : "支付宝" }}扫一扫打开
      </div>
    </van-action-sheet>
    <!-- <div style="margin: 40px 10px">
      <van-dialog
        v-model="showse"
        @confirm="confirma"
        title="支付金额"
        show-cancel-button
      >
        <div style="font-size: 30px; font-weight: 600">
          ￥{{ this.$route.query.type }}
        </div>
        <div style="margin-top: 10px; margin-bottom: 20px">
          <div
            class="content"
            v-for="item in zhifu"
            :key="item.id"
            style="text-align: left"
          >
            <img
              style="width: 20px; height: 20px; vertical-align: middle"
              src="../assets/前端/微信支付.png"
            />

            <span style="margin-left: 10px">{{ item.name }}</span>
            <el-radio
              style="float: right; margin-top: 2px"
              v-model="radio"
              size="medium"
              :label="item.id"
            >
              <br />
            </el-radio>
          </div>
        </div>
      </van-dialog>
    </div> -->
  </div>
</template>

<script>
  import { getPayList, PayPostAge, savePayPostAge } from "@/api/newPay";
  import {
    getProvinceModel,
    getCityModel,
    getAreaModel,
    getChangeCardSpecies,
  } from "@/api/address";
  export default {
    data() {
      return {
        //支付环境
        enm: 1,
        form: {
          oldCard: localStorage.getItem("meCardNum"),
          name: "",
          phone: "",
          city: "",
          remark: "",
          card: localStorage.getItem("meCardNum"),
          payId: "",
          code: "",
          changeCardSpeciesId: "",
        },
        // 支付列表
        newPayList: [],
        // 支付类型
        PayType: [],
        // 校验手机号码
        telRules: [
          {
            required: true,
            message: "手机号码不能为空",
            trigger: "onBlur",
          },
          {
            // 自定义校验规则
            validator: (value) => {
              return /^(?:(?:\+|00)86)?1\d{10}$/.test(value);
            },
            message: "请输入正确格式的手机号码",
            trigger: "onBlur",
          },
        ],
        imagerurl: "",
        showss: false,
        value: "",
        bnk: "",
        radio: "",
        columns: [],
        showPicker: false,
        values: "",
        zhifu: [],
        showse: false,
        showPicker3: false,
        columnss: [],
        showPickers: false,
        valuess: "",
        columnsss: [],
        showPickerss: false,
        cards: [],
        cardsId: "",
        appId: "",
        loadingsa: false,
      };
    },
    created() {},
    async mounted() {
      await this.getChangeCardSpecies();
      await this.is_weixn();
      await this.getLists();
      await this.getProvinceModel();
      await this.wx(this.$route.query.code, 0, this);
    },
    methods: {
      is_weixn() {
        var ua = navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
          this.enm = 3;
          return (this.qqs = true);
        } else {
          this.enm = 2;
          return (this.qqs = false);
        }
      },
      onConfirms1(value) {
        this.bnk = value.name;
        this.cardsId = value.id;
        this.form.changeCardSpeciesId = value.id;
        this.showPicker3 = false;
      },

      weixinSDK(appid, timeStamp, package2, nonceStr, paySign, type) {
        function onBridgeReady() {
          window.WeixinJSBridge.invoke(
            "getBrandWCPayRequest",
            {
              appId: appid,
              timeStamp: timeStamp,
              nonceStr: nonceStr,
              package: package2,
              signType: type,
              paySign: paySign,
            },
            function (res) {
              if (res.err_msg == "get_brand_wcpay_request:ok") {
                // 使用以上方式判断前端返回,微信团队郑重提示：
                //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                this.$router.push(`/home`);
              }
            }
          );
        }
        if (typeof WeixinJSBridge == "undefined") {
          if (document.addEventListener) {
            document.addEventListener(
              "WeixinJSBridgeReady",
              onBridgeReady,
              false
            );
          } else if (document.attachEvent) {
            document.attachEvent("WeixinJSBridgeReady", onBridgeReady);
            document.attachEvent("onWeixinJSBridgeReady", onBridgeReady);
          }
        } else {
          onBridgeReady();
        }
      },
      wx(code, type, than) {
        function jumpLink() {
          // var test = encodeURIComponent(window.location.href);
          // alert(test);
          // window.location =
          //   "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
          //   than.appId +
          //   "&redirect_uri=" +
          //   test +
          //   "&response_type=code&scope=snsapi_userinfo&state=" +
          //   than.time +
          //   "#wechat_redirect";
          // ("");
          than.form.name = encodeURI(than.form.name);
          than.form.city = encodeURI(than.form.city);
          than.form.remark = encodeURI(than.form.remark);
          const url = encodeURIComponent(
            window.location.protocol +
              "//" +
              window.location.host +
              "/weixinRedirect2/" +
              than.$route.query.type +
              "/" +
              than.form.payId +
              "?name=" +
              than.form.name +
              "&phone=" +
              than.form.phone +
              "&city=" +
              than.form.city +
              "&remark=" +
              than.form.remark +
              "&cardsId=" +
              than.cardsId +
              "&cardsName=" +
              than.bnk +
              "&id=" +
              than.$route.query.id
          );
          // alert(than.appId);
          // than.fom.next = localStorage.getItem("next");
          window.location.href =
            "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
            than.appId +
            "&response_type=code&scope=snsapi_userinfo&redirect_uri=" +
            url;
          // alert(localStorage.getItem("next"));
          // than.fom.next = localStorage.getItem("next");
        }
        getUserInfo();

        function getUserInfo() {
          if (code != null && code != undefined && code.trim() != "") {
            than.form.code = code;
            than.form.payId = than.$route.query.payId;
            than.form.name = decodeURI(than.$route.query.name);
            than.form.phone = than.$route.query.phone;
            than.form.city = decodeURI(than.$route.query.city);
            than.form.remark = decodeURI(than.$route.query.remark);
            than.form.changeCardSpeciesId = than.$route.query.cardsId;
            than.bnk = decodeURI(than.$route.query.cardsName);
            PayPostAge(than.form).then((res) => {
              if (res.status) {
                var obj = {};
                obj = res.data.body;
                console.log(obj);
                than.weixinSDK(
                  obj.appId,
                  obj.timeStamp,
                  obj.package,
                  obj.nonceStr,
                  obj.sign,
                  obj.signType
                );
              } else {
                than.$toast(res.msg);
              }
            });
          } else {
            if (type == 1) {
              jumpLink();
            }
            // than.fom.next = localStorage.getItem("next");
            // alert(than.fom.next);
          }
        }
      },
      getProvinceModel() {
        getProvinceModel().then((res) => {
          if (res.status) {
            this.columns = res.data;
            this.form.postAge = this.$route.query.type;
          }
        });
      },
      getChangeCardSpecies() {
        getChangeCardSpecies(Number(this.$route.query.id)).then((res) => {
          if (res.status) {
            this.cards = res.data;
          }
        });
      },
      //确认支付
      confirma() {
        var code;
        this.zhifu.forEach((item) => {
          if (this.form.payId == item.id) {
            this.appId = item.appId;
            code = item.code;
          }
        });
        if (code == 0 && this.PayType == 1 && this.qqs == true) {
          this.wx(null, 1, this);
        } else {
          if (code == 0) {
            this.imagerurl =
              window.location.protocol +
              "//" +
              window.location.host +
              `/app/qrcode/qrcode?content=${encodeURIComponent(
                `${window.location.protocol}//${
                  window.location.host
                }/wap/index.html#/wechat?appId=${
                  this.appId
                }&form=${JSON.stringify(this.form)}&address=${1}`
              )}`;
            this.showss = true;
          } else {
            this.PayPostAge(this.form);
          }
        }
      },
      //拉起支付
      PayPostAge(data) {
        PayPostAge(data).then((res) => {
          if (res.status) {
            if (res.data.payType == 2) {
              window.location.href = res.data.body;
            } else if (res.data.payType == 3) {
              this.imagerurl = `/app/qrcode/qrcode?content=${res.data.body}`;
              this.showss = true;
            }
          } else {
            this.$toast(res.msg);
          }
        });
      },
      onSubmit() {
        this.form.oldCard = localStorage.getItem("meCardNum");
        this.form.city =
          this.value + this.values + this.valuess + this.form.address;
        if (this.form.postAge == "0") {
          this.loadingsa = true;
          savePayPostAge(this.form).then((res) => {
            if (res.status) {
              this.loadingsa = false;
              this.$toast(res.msg);
              this.$router.push(`/success`);
            } else {
              this.$toast(res.msg);
            }
          });
        } else {
          this.newPayList.forEach((item) => {
            if (item.id == this.PayType) {
              this.zhifu = item.list;
              this.form.payId = this.zhifu[0].id;
              this.showse = true;
            }
          });
        }

        //
      },
      //支付列表
      getLists() {
        getPayList(this.enm).then((res) => {
          if (res.status) {
            res.data.forEach((item) => {
              item.list.forEach((items) => {
                items.imgUrl = item.imageUrl;
              });
            });
            this.newPayList = res.data;
            if (res.data > 0) {
              this.PayType = res.data[0].id;
            }
          } else {
            this.$toast(res.msg);
          }
        });
      },
      onConfirm(value) {
        console.log(value);
        this.value = value.name;
        getCityModel(value.province_code).then((res) => {
          if (res.status) {
            this.columnss = res.data;
          }
        });
        this.showPicker = false;
      },
      onConfirms(value) {
        console.log(value);
        this.values = value.name;
        getAreaModel(value.city_code).then((res) => {
          if (res.status) {
            this.columnsss = res.data;
          }
        });
        this.showPickers = false;
      },
      onConfirmss(value) {
        console.log(value);
        this.valuess = value.name;

        this.showPickerss = false;
      },
    },
  };
</script>

<style scoped lang="scss">
  .recommend {
    display: flex;
    align-items: center;
    width: 27px;
  }
  .recommends {
    background: #ffca66;
    color: #ffffff;
    width: 27px;
    text-align: center;
    font-size: 9px;
    height: 15px;
    border-radius: 3px;
  }
  .heard {
    font-size: 16px;
    color: #575757;
    background: #ffffff;
    height: 50px;
    line-height: 50px;
    text-align: center;
  }
  .img {
    width: 22px;
    height: 22px;
    vertical-align: middle;
  }
  .content {
    display: flex;
    justify-content: space-between;
    width: 100%;
    background-color: white;
    padding: 10px;
    color: black;
    font-size: 16px;
    box-sizing: border-box;
    border-top: 1px solid rgba(#009fff, 0.2);
    border-bottom: 1px solid rgba(#009fff, 0.2);
  }

  .recommend {
    display: flex;
    align-items: center;
    width: 27px;
  }
  .recommends {
    background: #ffca66;
    color: #ffffff;
    width: 27px;
    text-align: center;
    font-size: 9px;
    height: 15px;
    border-radius: 3px;
  }

  .center {
    margin: 15px;
    .title {
      height: 45px;
      line-height: 45px;
      font-size: 16px;
      text-align: center;
      color: #409eff;
      background: #ffffff;
      border-bottom: 1px solid #409eff;
      border-radius: 10px 10px 0 0;
    }
    .form {
      background: #ffffff;
      border-radius: 0 0 10px 10px;
      padding: 10px 0;
    }

    .detail-names {
      display: flex;
      align-content: center;
      justify-content: space-between;
      font-size: 14px;
      height: 30px;
      padding: 10px;
      text-align: left;
      border-bottom: 1px solid rgba(128, 128, 128, 0.1);
    }

    .display-left {
      display: flex;
      text-align: left;
      align-items: center;
      justify-self: left;
      width: 50%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .display-right {
      display: flex;
      align-items: center;
      width: 45%;
      justify-content: flex-end;
      margin-right: 5%;
    }
  }
</style>
